<template>
  <div class="ex-group" :class="{ close: close }" :style="{ '--accent': color || '#4fc3ff' }">
    <div class="ex-group-head" @click="handleClose">
      <span class="dot"></span>
      <div class="name">{{ name }}</div>
      <div class="scores">
        <span class="label">总得分</span>
        <span class="val">{{ score || 0 }}<small>分</small></span>
        <span class="arrow" :class="{ open: !close }"></span>
      </div>
    </div>

    <div class="ex-group-body">
      <table>
        <tr>
          <th>指标值</th>
          <th class="ms-col">指标分值</th>
          <th class="rate-col">评价</th>
        </tr>

        <tr v-for="(item, index) in list" :key="index">
          <td>{{ item.name }}</td>
          <td class="ms">{{ item.maxScore }}</td>
          <td class="rate">
            <el-rate :value="item.max || 0" void-color="rgba(255,255,255,.16)"
              disabled-void-color="rgba(255,255,255,.16)"
              :colors="['#5fb0ff', '#7ad1ff', '#ffd24a']"
              @change="(val) => onChange(val, item, index)"></el-rate>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
    name: "DimensionView",
    props: {
        name: String,
        color: String,
        open: Boolean,
        list: Array,
        score: Number,
        disabled: Boolean
    },
    data() {
        return {
            close: true,
            max: 0,//分数
        };
    },

    created() {
        this.close = !this.$props.open || false

    },
    methods: {
        handleClose() {
            if (this.$props.disabled) return false;
            this.close = !this.close;
        },
        onChange(val, item, childIndex) {
            let obj = {
                val: val,
                item: item,
                childIndex: childIndex
            }
            this.$emit('changeRule', obj)
        }
    }
};
</script>

<style lang="less" scoped>
.ex-group {
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid rgba(63, 156, 255, .2);
  background: linear-gradient(180deg, rgba(16, 45, 100, .35), rgba(6, 20, 50, .45));
  overflow: hidden;
}

.ex-group-head {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px;
  color: #eaf6ff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .5px;
  background: linear-gradient(90deg, rgba(42, 125, 232, .35), rgba(16, 60, 140, .18));
  border-bottom: 1px solid rgba(63, 156, 255, .25);
  user-select: none;

  &:hover {
    background: linear-gradient(90deg, rgba(42, 125, 232, .5), rgba(16, 60, 140, .25));
  }

  .dot {
    flex: none;
    width: 8px;
    height: 8px;
    background: var(--accent);
    transform: rotate(45deg);
    box-shadow: 0 0 8px var(--accent);
  }

  .name {
    flex: 1;
    min-width: 0;
    word-break: break-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .scores {
    flex: none;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .label {
    font-size: 11px;
    color: #7ea6d9;
    font-weight: 400;
  }

  .val {
    font-size: 15px;
    font-weight: 500;
    font-family: "DIN Alternate", "Segoe UI", Consolas, sans-serif;
    color: #ffd24a;
    text-shadow: 0 0 10px rgba(255, 210, 74, .4);

    small {
      font-size: 11px;
      margin-left: 1px;
    }
  }

  /* 折叠箭头 */
  .arrow {
    flex: none;
    width: 8px;
    height: 8px;
    margin-left: 4px;
    border-right: 1.5px solid #7ea6d9;
    border-bottom: 1.5px solid #7ea6d9;
    transform: rotate(45deg) translate(-2px, -2px);
    transition: transform .2s ease;
  }

  .arrow.open {
    transform: rotate(-135deg) translate(-2px, -2px);
  }
}

.ex-group.close {
  .ex-group-head {
    border-bottom-color: transparent;
  }

  .ex-group-body {
    display: none;
  }
}

.ex-group-body {
  padding: 10px 12px 12px;

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th,
  td {
    text-align: left;
    padding: 7px 10px;
    border-bottom: 1px solid rgba(63, 156, 255, .15);
  }

  th {
    font-size: 12px;
    font-weight: 400;
    color: #7ea6d9;
    background: rgba(27, 98, 224, .12);
    border-bottom: 1px solid rgba(63, 156, 255, .25);
  }

  td {
    font-size: 13px;
    color: #cfe6ff;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: rgba(42, 125, 232, .12);
  }

  .ms-col,
  .ms {
    width: 84px;
    text-align: center;
    color: #9ec7ff;
  }

  .rate-col,
  .rate {
    width: 140px;
  }

  /deep/ .el-rate {
    height: 20px;
    line-height: 20px;
    display: flex;
    align-items: center;
  }

  /deep/ .el-rate__icon {
    font-size: 17px;
    margin-right: 4px;
  }

  /deep/ .el-rate__item:last-child .el-rate__icon {
    margin-right: 0;
  }
}
</style>
